<template>
    <footer>
        <div class="flex justify-center items-center gap-2 sm:justify-end px-2 text-gray-500 mt-8">
            <span>Made with love by</span>
            <a href="https://churchhalo.app" target="_blank">
                <HaloLogo class="!h-6 mt-1" color="black"></HaloLogo>
            </a>
        </div>
        <div class="flex mt-2">
            <template v-for="color in colors" :key="color">
                <div class="h-2 w-1/4" :class="`${color} w-1/${colors.length}`"></div>
            </template>
        </div>
    </footer>
</template>

<script setup lang="ts">
import HaloLogo from '@/components/logos/HaloLogo.vue';

const colors = ['bg-halo-teal', 'bg-halo-aqua', 'bg-halo-gold', 'bg-halo-cobalt'];
</script>
